import { Checkbox, Divider, FormControlLabel, Grid, MenuItem, Select, Switch, TextField, Typography } from '@material-ui/core'
import { KeyboardDatePicker } from '@material-ui/pickers'
import React, { useContext, useEffect } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { FirebaseConfigKey, FirebaseService } from '../../../../services/FirebaseService'
import { isOver16, isOver18, prange } from '../../../../services/utils'
import { GlobalTextField } from '../../../Core/Input/ControlledTextField'
import EventIcon from '@material-ui/icons/Event'
import FlexView from 'react-flexview/lib'
import './RiderSection.scss'
import { PolicyModificationContextStore } from '../../../../context/PolicyModificationContext'
import { STATES } from '../../../../Constants'
import { ViolationList } from '../../../Operators/OperatorForm'
import { StatesContextStore } from '../../../../context/StatesContext'
import { stateWithActiveMilitaryDiscount } from '../../../../Constants'

export const RiderDetailsSection = ({ operatorVehicles, setOperatorVehicles }) => {
  const methods = useFormContext()
  const modifyContext = useContext(PolicyModificationContextStore)
  const statesContext = useContext(StatesContextStore)
  const state = modifyContext.owner_details.state
  const violations = methods.watch('insured_person_driving_history')
  const driverLicenseValidation = e => {
    const validCharactersRegex = /^[0-9a-zA-Z\b]+$/

    if (validCharactersRegex.test(e.target.value)) {
      e.target.value = e.target.value
    } else {
      e.target.value = e.target.value.replaceAll(/[^a-zA-Z0-9]/g, '')
    }
  }

  useEffect(() => {
    const isViolations = violations != undefined && violations.length > 0
    methods.setValue('recent_accident', isViolations)
  }, [])

  return (
    <React.Fragment>
      <div className="text-title bold black">Rider Details</div>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <FormControlLabel
            label="Also an Owner"
            control={<Controller name="is_owner" control={methods.control} as={<Checkbox color="primary" />} />}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography>{'First Name'}</Typography>
          <GlobalTextField
            fullWidth
            name="first_name"
            register={methods.register}
            inputProps={{ style: { textTransform: 'uppercase !important' } }}
            errors={methods.errors}
            helperText={!!methods.errors.first_name && 'Required'}
            inputRef={methods.register({ required: true })}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography>{'Last Name'}</Typography>
          <GlobalTextField
            fullWidth
            name="last_name"
            register={methods.register}
            inputProps={{ style: { textTransform: 'uppercase !important' } }}
            errors={methods.errors}
            helperText={!!methods.errors.last_name && 'Required'}
            inputRef={methods.register({ required: true })}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography>{'Date of Birth'}</Typography>
          <Controller
            as={
              <KeyboardDatePicker
                disableFuture
                fullWidth
                keyboardIcon={<EventIcon className="backbuttongray" />}
                openTo="year"
                views={['year', 'month', 'date']}
                error={!!methods.errors.date_of_birth}
                inputVariant="outlined"
                helperText={methods.errors.date_of_birth ? 'Must be 16 or older' : ''}
                format={FirebaseService.getValue(FirebaseConfigKey.LONG_DATE_FORMAT)}
              />
            }
            onChange={date => {
              if (date && date.length > 0 && date[0] != null) {
                methods.setValue('date_of_birth', new Date(date[0]))
                return new Date(date[0])
              } else {
                methods.setValue('date_of_birth', null)
                return methods.getValues()['date_of_birth']
              }
            }}
            rules={{ validate: tim => isOver16(new Date(tim)), required: true }}
            name="date_of_birth"
            value={methods.watch('date_of_birth')}
            defaultValue={methods.control.defaultValuesRef.current.date_of_birth || ''}
            control={methods.control}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography>{'Year of Experience'}</Typography>
          <Controller
            control={methods.control}
            rules={{ validate: x => x && x != 'default', required: true }}
            name="experience_years"
            disabled={
              modifyContext.isRenewal &&
              !!methods.control.defaultValuesRef.current.experience_years &&
              !!methods.control.defaultValuesRef.current.id
            }
            defaultValue={methods.control.defaultValuesRef.current.experience_years || 'default'}
            as={
              <TextField
                InputLabelProps={{ className: 'avenir-book' }}
                error={!!methods.errors.experience_years}
                variant="outlined"
                fullWidth
                select
              >
                <MenuItem disabled value={'default'}>
                  <div className="placeholder-text avenir-book">Riding experience</div>
                </MenuItem>
                {prange(1, 6, 1).map(val => (
                  <MenuItem key={val} value={val}>
                    {val}
                  </MenuItem>
                ))}
                <MenuItem value={6}>6+</MenuItem>
              </TextField>
            }
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography>{'Marital Status'}</Typography>
          <Controller
            control={methods.control}
            rules={{ validate: x => x && x != 'default', required: true }}
            defaultValue={methods.control.defaultValuesRef.current.is_married || 'default'}
            name="is_married"
            as={
              <TextField
                InputLabelProps={{ className: 'avenir-book' }}
                error={!!methods.errors.is_married}
                variant="outlined"
                fullWidth
                select
              >
                <MenuItem disabled value={'default'}>
                  <div className="placeholder-text avenir-book">Marital status</div>
                </MenuItem>
                <MenuItem value={'false'}>Single</MenuItem>
                <MenuItem value={'true'}>Married</MenuItem>
              </TextField>
            }
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography>{'Highest level of education'}</Typography>
          <Controller
            control={methods.control}
            rules={{ validate: x => x && x != 'default', required: true }}
            defaultValue={methods.control.defaultValuesRef.current.education_level || 'default'}
            name="education_level"
            as={
              <TextField
                InputLabelProps={{ className: 'avenir-book' }}
                error={!!methods.errors.education_level}
                variant="outlined"
                fullWidth
                select
              >
                <MenuItem disabled value={'default'}>
                  <div className="placeholder-text avenir-book">Highest level of education</div>
                </MenuItem>
                <MenuItem value={'NA'}>Hasn't Provided</MenuItem>
                <MenuItem value={'NoHSDiplomaOrGED'}>No HS diploma or GED </MenuItem>
                <MenuItem value={'HSDiplomaOrGED'}>HS diploma or GED </MenuItem>
                <MenuItem value={'VocationalOrTradeSchool'}>Vocational or trade school</MenuItem>
                <MenuItem value={'CompletedSomeCollege'}>Completed some college</MenuItem>
                <MenuItem value={'CurrentlyAttendingCollege'}>Currently attending college</MenuItem>
                <MenuItem value={'CollegeDegree'}>College degree</MenuItem>
                <MenuItem value={'GraduateWorkOrDegree'}>Graduate work or degree</MenuItem>
              </TextField>
            }
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography>{'Driver License'}</Typography>
          <GlobalTextField
            fullWidth
            name="driver_license"
            // disabled={!!methods.control.defaultValuesRef.current.driver_license && !!methods.control.defaultValuesRef.current.id}
            register={methods.register}
            errors={methods.errors}
            inputProps={{ style: { textTransform: 'uppercase' } }}
            onChange={driverLicenseValidation}
            helperText={
              !!methods.errors.driver_license &&
              (methods.errors.driver_license.type == 'required' ? 'Required' : "Invalid Driver's License")
            }
            inputRef={methods.register({ required: true })}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography>{'License State'}</Typography>
          <Controller
            control={methods.control}
            rules={{ validate: x => x && x != 'default', required: true }}
            name="license_state"
            // disabled={!!methods.control.defaultValuesRef.current.license_state && !!methods.control.defaultValuesRef.current.id}
            defaultValue={methods.control.defaultValuesRef.current.license_state || 'default'}
            as={
              <Select error={!!methods.errors.license_state} variant="outlined" fullWidth className="avenir-book">
                <MenuItem disabled value={'default'}>
                  <div className="placeholder-text">Driver's license state</div>
                </MenuItem>
                {Object.keys(STATES).map(t => (
                  <MenuItem key={t} value={STATES[t]}>
                    {STATES[t]}
                  </MenuItem>
                ))}
              </Select>
            }
          />
        </Grid>
        <Divider className="divider" />

        <Grid item xs={12}>
          <FlexView className="switch_question_style">
            <Typography>Is your driver’s license endorsed for motorcycle use?</Typography>
            <Controller name="license_endorsed_for_motorcycle" control={methods.control} as={<Switch color="primary" />} />
          </FlexView>
        </Grid>
        <Grid item xs={12}>
          <FlexView className="switch_question_style">
            <Typography>Have you taken a safety education course?</Typography>
            <Controller name="education_course" control={methods.control} as={<Switch color="primary" />} />
          </FlexView>
        </Grid>
        <Grid item xs={12}>
          <FlexView className="switch_question_style">
            {statesContext.residence_insurance_factor_states.includes(state) ? (
              <>
                <Typography>Do you own an insurance for your principal residence?</Typography>
                <Controller name="residence_insurance" control={methods.control} as={<Switch color="primary" />} />
              </>
            ) : (
              <>
                <Typography>Do you own a home?</Typography>
                <Controller name="own_home" control={methods.control} as={<Switch color="primary" />} />
              </>
            )}
          </FlexView>
        </Grid>
        <Grid item xs={12}>
          <FlexView className="switch_question_style">
            {stateWithActiveMilitaryDiscount.includes(state) && (
              <>
                <Typography>
                  Are you an active military personnel, or do you have a spouse or any dependent children under 18 (or unmarried full-time
                  students under 24) who are also active military personnel?
                </Typography>
                <Controller name="active_military" control={methods.control} as={<Switch color="primary" />} />
              </>
            )}
          </FlexView>
        </Grid>
        {!modifyContext.isRenewal && (
          <Grid item xs={12}>
            <div className="text-body bold black margin-bottom-basic">Riding History</div>
            <Typography>Have you had any violations or at-fault accidents causing more than $1000 damage in the past 3 years?</Typography>
            <Controller name="recent_accident" control={methods.control} as={<Switch color="primary" />} />
            {methods.watch('recent_accident') == true && (
              <>
                <div className="text-small black margin-bottom-basic">Please add the violations and the date each occured:</div>
                <ViolationList register={methods.register} control={methods.control} errors={methods.errors} setValue={methods.setValue} />
              </>
            )}
          </Grid>
        )}

        <Grid item xs={12}>
          <Typography>Motorcycle(s) rides on:</Typography>
          {modifyContext.motorcycles_details.map((m, i) => (
            <FlexView key={i} vAlignContent={'center'}>
              <FormControlLabel
                value={m.id}
                checked={operatorVehicles.filter(id => id == m.id).length > 0}
                onChange={e => {
                  let index = operatorVehicles.findIndex(id => id == m.id)
                  if (index == -1) setOperatorVehicles([...operatorVehicles, e.target.value])
                  else setOperatorVehicles(operatorVehicles.filter(x => x != e.target.value))
                }}
                control={<Checkbox color="primary" />}
              />
              <div className="text-body">
                {m.make} {m.model} {m.year}
              </div>
            </FlexView>
          ))}
        </Grid>
      </Grid>
    </React.Fragment>
  )
}
